import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { brokerHouseService } from './brokerHouseCode.service';
import { setAlertError, setAlertSuccess } from '../alert/alert.slice';

const initialState = {
  brokerCodes: [],
  loading: false,
  adding: false,
  updating: false,
  deleting: false
};

export const addBrokerHouseCode = createAsyncThunk(
  'brokerHouse/addBrokerHouseCode',
  async (data, thunkAPI) => {
    try {
      const response = await brokerHouseService.addBrokerHouseCode(data);
      thunkAPI.dispatch(setAlertSuccess('Broker house added successfully'));
      return response;
    } catch (error) {
      const err = error.response?.data || { message: 'Failed to add broker house.' };
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getBrokerHouseCodes = createAsyncThunk(
  'brokerHouse/getBrokerHouseCodes',
  async (_, thunkAPI) => {
    try {
      return await brokerHouseService.getBrokerHouseCodes();
    } catch (error) {
      const err = error.response?.data || { message: 'Failed to fetch broker houses.' };
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateBrokerHouseCode = createAsyncThunk(
  'brokerHouse/updateBrokerHouseCode',
  async (data, thunkAPI) => {
    try {
      const response = await brokerHouseService.updateBrokerHouseCode(data);
      thunkAPI.dispatch(setAlertSuccess('Broker house updated successfully'));
      return response;
    } catch (error) {
      const err = error.response?.data || { message: 'Failed to update broker house.' };
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteBorkerHouseCode = createAsyncThunk(
  'brokerHouse/deleteBorkerHouseCode',
  async (id, thunkAPI) => {
    try {
      const response = await brokerHouseService.deleteBorkerHouseCode(id);
      thunkAPI.dispatch(setAlertSuccess('Broker house deleted successfully'));
      return response;
    } catch (error) {
      const err = error.response?.data || { message: 'Failed to delete broker house.' };
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const BrokerHouseCodeSlice = createSlice({
  name: 'brokerHouse',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addBrokerHouseCode.pending, (state) => {
        state.adding = true;
      })
      .addCase(addBrokerHouseCode.fulfilled, (state, action) => {
        state.adding = false;
        state.brokerCodes.push(action.payload.data);
      })
      .addCase(addBrokerHouseCode.rejected, (state) => {
        state.adding = false;
      })
      .addCase(getBrokerHouseCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBrokerHouseCodes.fulfilled, (state, action) => {
        state.loading = false;
        state.brokerCodes = action.payload.data;
      })
      .addCase(getBrokerHouseCodes.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateBrokerHouseCode.pending, (state) => {
        state.updating = true;
      })
      .addCase(updateBrokerHouseCode.fulfilled, (state, action) => {
        state.updating = false;
      })
      .addCase(updateBrokerHouseCode.rejected, (state) => {
        state.updating = false;
      })
      .addCase(deleteBorkerHouseCode.pending, (state) => {
        state.deleting = true;
      })
      .addCase(deleteBorkerHouseCode.fulfilled, (state, action) => {
        state.deleting = false;
      })
      .addCase(deleteBorkerHouseCode.rejected, (state) => {
        state.deleting = false;
      });
  }
});

export default BrokerHouseCodeSlice.reducer;
